"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.talkTimeTranslations = {
    "en": {
        average: "Average",
        maximum: "Maximum",
        talkTime: "Talk Time",
        infoText: "The average and maximum talk times for the specified date range. Talk time represents\n        the amount of time an agent spent talking with a customer.",
    },
    "de": {
        infoText: "Die durchschnittlichen und maximalen Gespr\u00E4chszeiten f\u00FCr den angegebenen Zeitraum. Gespr\u00E4chszeit entspricht\n        der Zeitdauer, die ein Mitarbeiter mit einem Kunden im Gespr\u00E4ch war.",
        average: "Durchschnittlich",
        talkTime: "Gesprächszeit",
        maximum: "Maximal",
    },
    "nl": {
        infoText: "De gemiddelde en maximale praattijden voor het opgegeven datumbereik. Praattijd vertegenwoordigt\n        de hoeveelheid dat een agent met een klant gepraat heeft.",
        average: "Gemiddeld",
        talkTime: "Gesprekstijd",
        maximum: "Maximaal",
    },
    "it": {
        infoText: "I tempi di conversazione medi e massimi nel periodo specificato. Il tempo di conversazione indica\n        per quanto tempo un agente \u00E8 rimasto in chiamata con un cliente.",
        average: "Medio",
        talkTime: "Tempo di conversazione",
        maximum: "Massimo",
    },
    "fr": {
        infoText: "Les temps de parole moyen et maximal pour la plage de dates sp\u00E9cifi\u00E9e. Le temps de parole repr\u00E9sente\n        le temps qu'un agent a pass\u00E9 \u00E0 parler avec un client.",
        average: "Moyenne",
        talkTime: "Temps de parole",
        maximum: "Maximum",
    },
    "es": {
        infoText: "El tiempo medio de conversaci\u00F3n y el tiempo m\u00E1ximo de conversaci\u00F3n para el intervalo de fechas indicado. El tiempo de conversaci\u00F3n representa\n        la cantidad de tiempo que el agente pas\u00F3 hablando con el cliente.",
        average: "Promedio",
        talkTime: "Tiempo de conversación",
        maximum: "Máximo",
    },
    "ja": {
        infoText: "\u6307\u5B9A\u3055\u308C\u305F\u30C7\u30FC\u30BF\u7BC4\u56F2\u306B\u304A\u3051\u308B\u5E73\u5747\u5BFE\u8A71\u6642\u9593\u304A\u3088\u3073\u6700\u9577\u5BFE\u8A71\u6642\u9593\u5BFE\u8A71\u6642\u9593\u3068\u306F\n        \u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u304C\u30AB\u30B9\u30BF\u30DE\u30FC\u3068\u5BFE\u8A71\u3059\u308B\u306E\u306B\u4F7F\u3063\u305F\u6642\u9593\u3092\u8868\u3057\u307E\u3059\u3002",
        average: "平均",
        talkTime: "対話時間",
        maximum: "最長",
    },
    "en-GB": {
        infoText: "The average and maximum talk times for the specified date range. Talk time represents\n        the amount of time an agent spent talking with a customer.",
        average: "Average",
        talkTime: "Talk Time",
        maximum: "Maximum",
    },
    "ru": {
        average: "Среднее",
        maximum: "Максимальное",
        talkTime: "Время Разговора",
        infoText: "\u0421\u0440\u0435\u0434\u043D\u0435\u0435 \u0438 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u043A \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0440\u0430\u0437\u0433\u043E\u0432\u043E\u0440\u0430 \u0437\u0430 \u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0439 \u043F\u0440\u043E\u043C\u0435\u0436\u0443\u0442\u043E\u043A. \u0412\u0440\u0435\u043C\u044F \u0440\u0430\u0437\u0433\u043E\u0432\u043E\u0440\u0430\n         - \u044D\u0442\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438, \u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u0430\u0433\u0435\u043D\u0442 \u043F\u0440\u043E\u0432\u0435\u043B \u043D\u0430 \u043B\u0438\u043D\u0438\u0438 \u0441 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u043C.",
    },
};
